// webpack require.context scans the folder at build time — no Vite needed.
const ctx = require.context(
    '../../assets/img/gallery',
    true,
    /\.(jpg|jpeg|png|webp|avif|gif|svg)$/i
);

const projectFilterData = ctx.keys().map((path) => {
    // path looks like: ./samarinda/samarinda (1).webp
    const parts = path.split('/');
    const category = parts[parts.length - 2]; // folder name

    return {
        id: path,
        image: ctx(path),
        category,
    };
});

export default projectFilterData;
